import React, {useContext, useEffect } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/Mainmenu'
import Table from '../../Components/TableComponent'
// import {PE_VC_TABLE_QUERY} from '../../Queries/Pe';
import Card from '../../Components/ListPageCard/Card'
import RefineSearch from '../../Components/RefineSearchComponent'
import FilterTag from '../../Components/Tag'
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import Constants from '../../Constants';
import InvestmentRefineSearch from '../../Components/RefineSearch/InvestmentRefineSearch';
import { useLocation } from 'react-router-dom';
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Switch, Tooltip } from "antd";
import { UserContext } from "../../Contexts/UserContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../../hooks/useChartAnalytics";
/**
 * The function `Vc` is a React component that renders a layout with a top navigation bar, a main
 * section with a primary column and a secondary column, and a bottom section.
 * @returns The function `Vc` returns JSX elements that make up the layout of a page. It includes a top
 * navigation bar, a main section with a primary column and a secondary column, and a bottom section.
 * The primary column contains a filter tag, a main menu, and a table. The secondary column contains a
 * refine search component.
 */
function Vc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation(); 
    const { refineSearchFilters, dealsView,isMobile, setDealsView, switchValue, setSwitchValue, setrefineSearchFilters } = useContext(PeFilterContext);
    const { isDirectoryUser } = useContext(UserContext);

    const { pathname } = useLocation();
    
    // Use chart analytics hook
    const {
        showChartPopup,
        setShowChartPopup,
        currentChartData,
        setCurrentChartData,
        isChartLoading,
        setIsChartLoading,
        currentShowBy,
        fallbackChartData,
        getAvailableShowByOptions,
        handleChartIconClick,
        handleShowByChange,
        interval,
        handleIntervalChange,
        period,
        handlePeriodChange
    } = useChartAnalytics("vc", pathname);
    
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    useEffect(() => {
        setrefineSearchFilters((prev) => ({
            ...prev,
            ['/vc/companies']: {
                ...prev['/vc/companies'],
                exitStatus:[]
            }
        }))
    }, [])

    return (
        <Layout>
        <div className="flex min-h-screen h-screen flex-col">
                    {/* Top nav*/}
                  { <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? 'opacity-0 -translate-y-4 h-0 overflow-hidden' : 'opacity-100 translate-y-0'}`}>{!showChartPopup && <Card/>} </div>}  
                    {/* Bottom section */}
                    <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? "mt-12" : ""} flex min-h-0 flex-1 overflow-hidden`}>
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                                <div className="mr-[4.25rem] flex justify-between items-center">
                                <FilterTag />
                                {/* <div className='px-3'> */}
                                <ToggleDealsViewButton handleChartIconClick={handleChartIconClick}/>
                                </div>
                                {/* Your content */}
                                <MainMenu 
                                    active={1} 
                                    menu="vc" 
                                    primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                    subTypeMasterId={Constants.primaryMasterSubIds.vc_investments_id}
                                    typeId={Constants.moduleIds.companiesId}
                                    exportFileName={Constants.exportNames.vc_company_investment}
                                /> 
                                <div className='overflow-y-auto h-full'>
                                    {showChartPopup ? (
                                        <ChartPopup
                                            isOpen={showChartPopup}
                                            onClose={() => {
                                                setShowChartPopup(false);
                                                setIsChartLoading(false);
                                                setCurrentChartData(null);
                                            }}
                                            data={currentChartData || fallbackChartData}
                                            isLoading={isChartLoading}
                                            showBy={currentShowBy}
                                            availableShowByOptions={getAvailableShowByOptions()}
                                            onShowByChange={handleShowByChange}
                                            menuType="vc"
                                            subType="VC Investments"
                                            interval={interval}
                                            onIntervalChange={handleIntervalChange}
                                            period={period}
                                            onPeriodChange={handlePeriodChange}
                                            redirectPath={pathname}
                                        />
                                    ) : <Table menu="vc" sub_type_master_id={Constants.subCategoryIds.vc_investments_id}/>}
                                </div>
                                {/* </div> */}
                            </section>
                            {/* Secondary column (hidden on smaller screens) */}
                            <aside className={`order-first block flex-shrink-0 ${isMobile ? "pt-14" : ""}`}>
                                <div className="relative flex flex-col border-r border-gray-200 bg-[#FAF5EA]">
                                    {/* Your content */}
                                    <RefineSearch>
                                        <InvestmentRefineSearch customPathname={location.pathname} menu="vc" generalPathname={'/vc/companies'}/>
                                    </RefineSearch>
                                </div>
                            </aside>
                        </main>
                    </div>                   
                       
                </div>
        </Layout>
    )
}

export default Vc
